import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Plene silentis la urbo sub varma vent’, <br/>
        Tril’ najtingala karesis ja nin. <br/>
        Blankaj grapoloj kun ĉarma aroma sent’ <br/>
        Nin ebriigis pli forte ol vin’.
      </p>

      <p class="poem-block mb-3">
        Spiris ĝarden’ per freŝeco printempa jam, <br/>
        Plenis de akvo malluma ravin’… <br/>
        Enprofunditaj en nia unua am’, <br/>
        Estis ni junaj, feliĉaj sen fin’.
      </p>

      <p class="poem-block mb-3">
        Pasos la tempo, la harojn blankigos ĝi, <br/>
        Ŝiros foliojn de la robini’; <br/>
        Nure la vintro blizarde kaj kun pasi’ <br/>
        Rememorigos pri ili al ni.
      </p>

      <p class="poem-block mb-3">
        Kiam la vent’ furiozas sub firmament’, <br/>
        Pensas mi triste kun akra dolor’: <br/>
        Blankaj grapoloj kun ĉarma aroma sent’ <br/>
        Restos ja sole en mia memor’. <br/>
        Restos por ĉiam en mia memor’. 
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Romanco pri blanka akacio'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['X9l9O_NMPY4', '3WkeGG4NeTA'],
    itemTranslator: `
      Muziko: V. Basner, <br/>
      Teksto: M. Matusovskij, <br/>
      ${translator.esp}
    `
  }
}

export default item;